export const API_BASE_URL = "https://intermann-v2.herokuapp.com/";
// export const API_BASE_URL = "http://localhost:8080/";

export const ACCESS_TOKEN_NAME = "x-auth-token";